import { GetAllSegmentsResponse, SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';
import { duration, int64, timestamp, Timestamp } from '@fullstory/proto/google/protobuf';
import { MockGetAllResponseParams } from '@fullstory/ui-mocks/utils/types';
import { mockSegmentDetail } from './utils';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';

export const GET_ALL_SEGMENTS_RESPONSE: GetAllSegmentsResponse = { segments: [] };

export const mockGetAllSegmentsResponse = ({
  numberOfObjects = 10,
}: MockGetAllResponseParams): GetAllSegmentsResponse => {
  const testSegments: SegmentDetail[] = [];
  if (numberOfObjects > 0) {
    testSegments.push(
      mockSegmentDetail({
        id: 'testSegment',
        name: 'test segment with a very very very very very very very very very long name',
      }),
    );
  }
  for (let i = 0; i < numberOfObjects - 1; i++) {
    const segmentId = `testSegment${i}`;
    testSegments.push(
      mockSegmentDetail({
        id: segmentId,
        name: `Test Segment ${i}`,
        lastViewed: i % 2 === 0 ? null : Timestamp.now(),
        starred: i % 3 === 0 ? true : false,
      }),
    );
  }

  return {
    segments: testSegments,
  };
};

export const EVERYONE_SEGMENT = {
  starred: false,
  lastViewed: null,
  segment: {
    segment: {
      id: 'everyone',
      name: 'Everyone',
      description: '',
      segmentDefinition: {
        userProperties: [],
        excludeUserProperties: [],
        behaviors: [],
        excludeBehaviors: [],
        constraints: {
          inOrder: false,
          inSameSession: false,
          platform: 0,
          timeRange: { startTime: 'NOW/DAY-29DAY', endTime: 'NOW/DAY+1DAY' },
          completeSessions: false,
          withinTime: null,
          eventThresholds: [],
        },
        excludeConstraints: null,
      },
    },
    segmentMetadata: { canned: true },
    metadata: {
      lastUpdated: null,
      lastUpdatedBy: 'system',
      created: null,
      createdBy: 'system',
      archived: false,
      visibility: Visibility.PUBLIC,
      version: '1' as int64,
      sequentialVersion: '1' as int64,
    },
  },
};

export const rageClickSegment: SegmentDetail = {
  segment: {
    segment: {
      id: 'rageClicks',
      name: 'Rage clicked recently',
      description: '',
      segmentDefinition: {
        userProperties: [],
        excludeUserProperties: [],
        behaviors: [
          {
            event: {
              primary: {
                rageClick: {
                  any: {},
                },
              },
              deps: [],
            },
          },
        ],
        excludeBehaviors: [],
        constraints: {
          inOrder: false,
          inSameSession: false,
          platform: 0,
          timeRange: {
            startTime: 'NOW/DAY-6DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          completeSessions: false,
          withinTime: '0s' as duration,
          eventThresholds: [],
        },
        excludeConstraints: null,
      },
    },
    segmentMetadata: {
      canned: true,
    },
    metadata: {
      lastUpdated: null,
      lastUpdatedBy: 'system',
      created: null,
      createdBy: 'system',
      archived: false,
      visibility: Visibility.PUBLIC,
      version: int64.fromNumber(0),
      sequentialVersion: int64.fromNumber(0),
    },
  },
  starred: true,
  lastViewed: '2022-11-01T05:57:49.404Z' as timestamp,
};

export const GET_ALL_SEGMENTS_EVERYONE_SEGMENT_ONLY: GetAllSegmentsResponse = {
  segments: [EVERYONE_SEGMENT],
};
